function checkingHeader() {
  const app = document.getElementById('app')
  app.style.position = 'relative'
}

export const filtrationMobail = () => {
  checkingHeader()
}
